<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>题库</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <!-- <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="代码:" prop="code">
                          <el-input
                            id="code"
                            v-model="SelectData.code"
                            clearable
                            :readonly="IsReadonlyCode"
                          />
                        </el-form-item>
                      </div>
                    </el-col> -->
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="题库名称:" prop="name">
                          <el-input
                            id="name"
                            v-model="SelectData.name"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="分类:" prop="category">
                          <!-- <el-input
                            id="category"
                            v-model="SelectData.category"
                            clearable
                            :readonly="IsReadonly"
                          /> -->

                          <el-select
                            style="width: 20rem"
                            v-model="SelectData.categoryId"
                            :disabled="IsReadonly"
                            class="m-2"
                            placeholder="分类"
                            size="small"
                          >
                            <el-option
                              v-for="item in CourseCategoryList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>

                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <label for="description" class="textarea-note"
                          >描述:</label
                        >
                        <el-input
                          id="description"
                          type="textarea"
                          v-model="SelectData.description"
                          clearable
                          :readonly="IsReadonly"
                        />
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>

import {
  SelectQuestionBankById,
  ModifyQuestionBank,
  AddQuestionBank,
} from "@api/Exam/ApiQuestionBank";

import { CategoryDataList } from "@/assets/apiData/Exam/QuestionBank";
import {GetDataCourseCategory2} from  "@api/ApiCourseCategory";

export default {
  name: "QuestionBankEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      CourseCategoryList:[]
    };
  },
  created() {},
  mounted() {

  },
  methods: {
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      //debugger;
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;

      _this.GetDataCourseCategory2()

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData = {};
        return;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }
      SelectQuestionBankById(id).then(function (data) {
        _this.SelectData = data;
      });
    },
    //获取课程分类的二级分类
    GetDataCourseCategory2(){
      let _this = this
      GetDataCourseCategory2().then(res=>{
        _this.CourseCategoryList = res.entities
      }).catch(res=>{
        console.log(res)
      })
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;
      if(!this.validate())return;
      if (_this.OpStatus == "Add") {
        AddQuestionBank(_this.SelectData).then(function (data) {
          _this.$message.success("新增成功!");
          _this.$emit("handle-confirm");
        }).catch(res=>{
          _this.$message.success(res.message);
        });
      } else if (_this.OpStatus == "Modify") {
        ModifyQuestionBank(_this.SelectData).then(function (data) {
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        });
      }
    },
    validate() {
      if (!this.SelectData.name || this.SelectData.name == "") {
        this.$message.error("代码是必须的!");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.tyyzm ::v-deep .el-form-item__label {
  width: 120px;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
